import { testSettings } from "@/utils/testSettings"

export interface ITestSettingsPreset {
  id: string
  name: string
  settings: ITestNewGameSettings
}

const PRESETS_KEY = "mono.testSettingsPresets"
const ACTIVE_KEY = "mono.testSettingsActivePresetId"

// Default map for test settings: "1" (minimap).
export const DEFAULT_TEST_MAP_ID = "1"

export const makePresetId = () => `preset-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`

export const getPresets = (): ITestSettingsPreset[] => {
  try {
    const raw = localStorage.getItem(PRESETS_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []
    return parsed
  } catch (e) {
    console.error("Failed to read test settings presets", e)
    return []
  }
}

export const savePresets = (presets: ITestSettingsPreset[]) => {
  localStorage.setItem(PRESETS_KEY, JSON.stringify(presets))
}

export const getActivePresetId = (): string | null => {
  return localStorage.getItem(ACTIVE_KEY)
}

export const setActivePresetId = (id: string | null) => {
  if (id) localStorage.setItem(ACTIVE_KEY, id)
  else localStorage.removeItem(ACTIVE_KEY)
}

/**
 * Ensures there's always at least one preset to work with. If none exist yet,
 * seeds one from the existing hardcoded testSettings so we don't start empty.
 */
export const ensureInitialPreset = (): ITestSettingsPreset[] => {
  const existing = getPresets()
  if (existing.length > 0) return existing
  const seeded: ITestSettingsPreset = {
    id: makePresetId(),
    name: "Default",
    // testJailFreeCards is intentionally excluded from the UI editor.
    settings: { mapId: DEFAULT_TEST_MAP_ID, ...testSettings, testJailFreeCards: undefined },
  }
  savePresets([seeded])
  setActivePresetId(seeded.id)
  return [seeded]
}

export const getActivePreset = (): ITestSettingsPreset | null => {
  const presets = getPresets()
  if (presets.length === 0) return null
  const activeId = getActivePresetId()
  return presets.find((p) => p.id === activeId) || presets[0]
}
